import { render, staticRenderFns } from "./marketAnalysis.vue?vue&type=template&id=a84fe68c&scoped=true"
import script from "./marketAnalysis.vue?vue&type=script&lang=js"
export * from "./marketAnalysis.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=a84fe68c&prod&lang=scss&scoped=true&external"
import style1 from "./marketAnalysis.vue?vue&type=style&index=1&id=a84fe68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84fe68c",
  null
  
)

export default component.exports